export default __webpack_public_path__ + "static/team-img3-a76b0df3a386be4805d50832b527b43b.jpg";